import { Pipe, PipeTransform } from '@angular/core';
import { DeviceProcessingModes, DeviceProcessingModesWithSurface } from '../../../modules/devices/device.helper';

function convertMode(mode: string): string {
  // console.log('Convert mode', mode, DeviceProcessingModesWithSurface[mode]);
  if (!mode) {
    return '';
  }
  if (!DeviceProcessingModes[mode]) {
    // eslint-disable-next-line no-console
    console.error('Cannot translate mode', mode);
  }
  return DeviceProcessingModes[mode] || mode;
}

@Pipe({
  name: 'deviceProcMode',
})
export class DeviceProcModePipe implements PipeTransform {

  transform(mode: string): string {
    return convertMode(mode as string);
  }
}
